import httpClientImmigration from "@/services/httpClientImmigration";
import { server } from "@/services/constants";

export const getAll_im_nationality = () => {
         return httpClientImmigration.get(server.IM_NATIONALITY + `/getAll`);
       };

export const Create_im_nationality = (data) => {
         return httpClientImmigration.post(server.IM_NATIONALITY, data);
       };

export const update_im_nationality = (id, data) => {
         return httpClientImmigration.put(
           server.IM_NATIONALITY + `/${id}`,
           data,
         );
       };

export const Delete_im_nationality = (id) => {
  return httpClientImmigration.delete(server.IM_NATIONALITY + `/${id}`);
};
